import PropTypes from 'prop-types'
import { KIND } from 'baseui/button'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { ModalSection } from '@/shared/components/SDComponents/SDModal/styled-components'
import useClubSelectra from '@/containers/SubscriptionFormPageNew/Components/ClubSelectra/useClubSelectra'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'

const ClubSelectra = ({ version, module, hidden }) => {
  const { t, labelsToShow, disabled, isLoading, message, error, isClubSelectraRegistered, createClubSelectra } =
    useClubSelectra({ version, module })

  if (hidden) {
    return null
  }

  return (
    <ModalSection>
      <SDButton
        kind={KIND.secondary}
        block={true}
        isLoading={isLoading}
        onClick={createClubSelectra}
        disabled={disabled}
        overrides={{
          BaseButton: {
            style: () => ({
              marginTop: '.5rem',
            }),
          },
        }}
      >
        {isClubSelectraRegistered === true
          ? t('subscriptionForm:header.modal_save_send.club_selectra_sent')
          : t('subscriptionForm:header.modal_save_send.club_selectra')}
      </SDButton>
      {labelsToShow?.length > 0 && (
        <div role='alert' style={{ marginTop: 8, fontSize: 12 }}>
          {t('subscriptionForm:header.modal_save_send.club_selectra_missing_fields')} {labelsToShow.join(', ')}
        </div>
      )}

      {message.length > 0 && (
        <SDNotification
          type='positive'
          icon={false}
          primaryText={message}
          overrides={{
            style: {
              paddingTop: '0.5rem',
              paddingRight: '0.5rem',
              paddingBottom: '0.5rem',
              paddingLeft: '0.5rem',
              marginTop: '0.5rem',
            },
          }}
        />
      )}

      {error.length > 0 && (
        <SDNotification
          type='negative'
          icon={false}
          primaryText={error}
          overrides={{
            style: {
              paddingTop: '0.5rem',
              paddingRight: '0.5rem',
              paddingBottom: '0.5rem',
              paddingLeft: '0.5rem',
              marginTop: '0.5rem',
            },
          }}
        />
      )}
    </ModalSection>
  )
}

ClubSelectra.propTypes = {
  version: PropTypes.string,
}

export default ClubSelectra
